/* EZ Covers — reviews row auto-advance. Turns .ez-reviews__grid (a horizontal
   scroll-snap row) into a gentle auto-scrolling carousel: advances one card every
   ~5s, pauses on hover/focus/touch, loops at the end. Honours reduced-motion
   (no autoplay — manual scroll/swipe still works). Also makes the row keyboard-
   scrollable. Safe to include on multiple templates (guarded + per-element flag). */
(function () {
  if (window.__ezReviewsCarousel) return;
  window.__ezReviewsCarousel = true;

  function init(grid) {
    if (grid.__ezInit) return;
    grid.__ezInit = true;
    var cards = grid.querySelectorAll('.ez-review');
    if (cards.length < 2) return;

    grid.setAttribute('role', 'region');
    grid.setAttribute('aria-label', 'Customer reviews — scroll for more');
    grid.setAttribute('tabindex', '0');

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var paused = false;
    ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (e) {
      grid.addEventListener(e, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (e) {
      grid.addEventListener(e, function () { paused = false; });
    });

    setInterval(function () {
      if (paused || !grid.offsetParent) return; // skip while hovered/focused or hidden
      var cs = getComputedStyle(grid);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var step = cards[0].offsetWidth + gap;
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
      grid.scrollTo({ left: atEnd ? 0 : grid.scrollLeft + step, behavior: 'smooth' });
    }, 2000);
  }

  function initAll() {
    var grids = document.querySelectorAll('.ez-reviews__grid');
    for (var i = 0; i < grids.length; i++) init(grids[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
